import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { loadWorldConfig } from './config';

// Load the district config (station/host/name from the BACKEND .env) BEFORE the
// app renders, so the audio + clock use the right station from the first frame.
// loadWorldConfig always resolves (timeout + fallback), so render never hangs.
loadWorldConfig().finally(() => {
  createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
